<template>
  <div>

    <div ref="getTodayData" style="height:400px;"></div>

    <div ref="getHistoryData" style="height:400px;"></div>


    <div>
        <span style="color:red;">
            评价次数最多5项
        </span>
      <div v-for="item in evaTopList.EvaCountTopList" :key="item">
        {{item}}
      </div>


      <span style="color:red;">
            加分最多5项
        </span>
      <div v-for="item in evaTopList.EvaScoreAddTopList" :key="item">
        {{item}}
      </div>

      <span style="color:red;">
            减分最多5项
        </span>
      <div v-for="item in evaTopList.EvaScoreMinusTopList" :key="item">
        {{item}}
      </div>

      <span style="color:red;">
            最近5条评价记录
        </span>
      <div v-for="item in evaTopList.EvaRecentTopList" :key="item">
        {{item}}
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        apiPath: "/api/MoralEducationEvaData/",
        menus: [],
        modal_loading: false,
        loading: true,

        //Top 榜中榜
        evaTopList: [],
        todayChart: null,
        historyChart: null
      };
    },
    components: {},
    created: function() {

    },
    mounted: function () {


      this.GetTodayData();
      this.GetHistoryData();

      window.onresize = function () {

        this.todayChart.resize();
        this.historyChart.resize();
      };
    },
    methods: {

      //当天维度评价次数--柱状图
      async GetTodayData () {

        // 基于准备好的dom，初始化echarts实例
        this.todayChart = this.echarts.init(this.$refs.getTodayData);
        // 指定图表的配置项和数据
        var option = {
          title: {
            text: '维度评价次数',
            subtext: ''
          },
          color: ['#3398DB'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisTick: {
                alignWithLabel: true
              },
              axisLabel: {
                interval: 0,
                formatter: (value)=> {
                  return this.formatterEllipsis(value);
                }
              },
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '评价次数',
              type: 'bar',
              barWidth: '60%',
              data: []
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        this.todayChart.setOption(option);
        this.todayChart.showLoading();

        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetTodayData'
        );
        if (res.success) {
          var xAxisDataList = [];
          var seriesDataList = [];

          if(res.data!==null){
            Object.keys(res.data).forEach(function(key){
              xAxisDataList.push(key);
              seriesDataList.push(res.data[key]);
            });
          }
          option.xAxis[0].data = xAxisDataList;
          option.series[0].data = seriesDataList;

          this.todayChart.hideLoading();
          this.todayChart.setOption(option, true);

          this.evaTopList = {
            "EvaCountTopList": res.data.EvaCountTopList,
            "EvaRecentTopList": res.data.EvaRecentTopList,
            "EvaScoreAddTopList": res.data.EvaScoreAddTopList,
            "EvaScoreMinusTopList": res.data.EvaScoreMinusTopList,
          };

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }
      },


      //近7天N维度的趋势--折线图
      async GetHistoryData () {

        // 基于准备好的dom，初始化echarts实例
        this.historyChart = this.echarts.init(this.$refs.getHistoryData);
        // 指定图表的配置项和数据
        var option = {
          title: {
            text: '德育评价趋势',
            subtext: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            show: false,
            //data: ['最高气温', '最低气温']
          },
          toolbox: {
            show: false,
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              dataView: { readOnly: false },
              magicType: { type: ['line', 'bar'] },
              restore: {},
              saveAsImage: {}
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          },
          series: [
            //{
            //    name: '最高气温',
            //    type: 'line',
            //    data: [11, 11, 15, 13, 12, 13, 10],
            //    markPoint: {
            //        data: [
            //            { type: 'max', name: '最大值' },
            //            { type: 'min', name: '最小值' }
            //        ]
            //    },
            //    markLine: {
            //        data: [
            //            { type: 'average', name: '平均值' }
            //        ]
            //    }
            //},
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        this.historyChart.setOption(option);
        this.historyChart.showLoading();
        let res = await this.xyapi.get(
          this.$store.state.apiPath + this.apiPath + 'GetHistoryData'
        );
        if (res.success) {
          var xAxisDataList = [];
          var seriesDataList = [];
          res.data.dayList.forEach((dayItem)=>{
            xAxisDataList.push(dayItem);
          })
          if(res.data.DimensionEvaScoreDic!==null){
            Object.keys(res.data.DimensionEvaScoreDic).forEach(function(key){
              xAxisDataList.push(key);
              seriesDataList.push(res.data[key]);
              var temp = {
                name: key,
                type: 'line',
                data: res.data[key],//[11, 11, 15, 13, 12, 13, 10],
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' }
                  ]
                },
                markLine: {
                  //data: [
                  //    { type: 'average', name: '平均值' }
                  //]
                }
              };
              seriesDataList.push(temp);
            });
          }

          option.xAxis.data = xAxisDataList;
          option.series = seriesDataList;

          this.historyChart.hideLoading();
          this.historyChart.setOption(option, true);

        } else {
          this.xy.msgError(res.msg);
          // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }
      },

      formatterEllipsis: function () {
        let value = "";
        let maxLength = 3;//每项显示文字个数
        if (arguments.length === 1) {
          value = arguments[0];
        } else if (arguments.length === 2) {
          value = arguments[0];
          maxLength = arguments[1];
        } else {
          return "";
        }

        // let ret = "";//拼接加\n返回的类目项
        let valLength = value.length;//X轴类目项的文字个数
        let rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
        if (rowN > 1)//如果类目项的文字大于3,
        {
          return value.substring(0, maxLength) + "...";
        }
        else {
          return value;
        }
      },
    }
  };
</script>
<style lang='less' >

</style>

